import { render } from "./GlobalUser.vue?vue&type=template&id=1fb313de&scoped=true"
import script from "./GlobalUser.vue?vue&type=script&lang=js"
export * from "./GlobalUser.vue?vue&type=script&lang=js"

import "./GlobalUser.vue?vue&type=style&index=0&id=1fb313de&scoped=true&lang=css"

import exportComponent from "/Users/vincentblin/Sites/ONET-WA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb313de"]])

export default __exports__